<script setup>
import { computed } from "vue";
import store from "../../store";
import router from "../../router";

const userName = computed(() => store.state.user.username);
const isAdmin = computed(() => store.state.user.isAdmin);

function logout() {
  localStorage.removeItem("refresh");
  localStorage.removeItem("access_token");
  localStorage.removeItem("username");
  store.state.user.isAdmin = false;
  store.state.user.token = undefined;
  store.state.user.refresh = undefined;
  store.state.user.loggedIn = false;
  store.state.user.username = "";
  router.push({ name: "login" });
}
</script>

<template>
  <div class="layout-topbar">
    <div class="topbar-left">
      <router-link to="/" class="topbar-home-btn">
        <i class="pi pi-th-large topbar-home-icon" />
      </router-link>
      <router-link to="/">
        <img src="/images/logo-dark.svg" alt="Logo" class="topbar-brand-logo" />
      </router-link>
    </div>

    <div class="topbar-right">
      <span class="topbar-username">{{ userName }}</span>
      <button v-if="isAdmin" class="topbar-logout" title="Logout" @click="logout">
        <i class="pi pi-sign-out" />
      </button>
    </div>
  </div>
</template>
